// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/style/reset.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import {uploadAxios, downloadAxios, downloadImgFile,uploadAxiosPath} from './utils/uploadDownloadFile'
import {stringToByte, byteToString, deepCopy, getDateTime} from './utils/strToBytes'
import md5 from 'js-md5'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$md5 = md5
Vue.prototype.$uploadAxios = uploadAxios
Vue.prototype.$downloadAxios = downloadAxios
Vue.prototype.$uploadAxiosPath = uploadAxiosPath

Vue.prototype.$downloadImgFile = downloadImgFile
Vue.prototype.$deepCopy = deepCopy // 深拷贝
Vue.prototype.$getDateTime = getDateTime // 日期转毫秒数

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js